import axios from "axios"
import {useSelector} from "react-redux"
// import {url} from "../"
import React from 'react'

axios.defaults.baseURL="https://ecombackend-n9in.onrender.com/";


    
export  const handleCheckOut=async(productsAdded)=>{
    
        try {
            const payment=await axios.post("/api/stripe/create-checkout-session",{cartItem:"cattItem",productsAdded})
            
            
            if(payment.data.url){
                window.location.href=payment.data.url
            }

        } catch (error) {
            console.log({error});            
        }
        
    }

